/* eslint-disable no-shadow, no-unused-vars */

import async from 'app/legacy/vendor/async';

/* backbone fetch + async lib helper method, automatically routes
 * the callback from success/error to the async required callback
 */
async.fetch = function(model, options) {
  return function(callback) {
    return model.fetch({
      cache:
        (options != null ? options.cache : void 0) != null
          ? options.cache
          : true,
      persist:
        (options != null ? options.persist : void 0) != null
          ? options.persist
          : false,
      add:
        (options != null ? options.add : void 0) != null ? options.add : null,
      success: function(model, response, options) {
        return callback(null, model);
      },
      error: function(model, response, options) {
        if (options != null ? options.canFail : void 0) {
          return callback(null, model);
        } else {
          return callback(response, model);
        }
      },
    });
  };
};
